export default __webpack_public_path__ + "static/media/Shal-e-Pashm_compressed.e62bbfd9.png";